import { Monitor } from '~types/index'
import isRestrictedOperation from './operationReport'

const GQLmonitor: Monitor = (type, observer) => {
  let mapped = JSON.stringify({
    operationName: observer.operationName,
  })
  if (type === 'deadpool-request') {
    if (!isRestrictedOperation(observer.operationName || '')) {
      mapped = JSON.stringify({
        operationName: observer.operationName,
        variables: observer.variables,
      })
    }
    console.log('Monitor - request', mapped)
  }
  if (type === 'deadpool-response') {
    const { time = 0 } = observer

    const fromCache = time < 5
    mapped = JSON.stringify({ time, fromCache })
    if (!isRestrictedOperation(observer.operationName || '')) {
      console.log(`Monitor - response ${observer?.operationName || ''}`, mapped)
    }
  }
  return mapped
}

export default GQLmonitor
